import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useContext, useState } from "react";

import { Skeleton, Tooltip } from "@mui/material";
import BrandIndexBreakups from "../../../Component/BrandIndexHistory/BrandIndexBreakups";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import Modal from "../../../Component/Modal/Modal";
import WeightedDonutChart from "../../../Component/WeightedDonutChart/WeightedDonutChart";
import MUICard from "../../../Component/UI/MUICard/MUICard";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { DiscoveryContext } from "../discovery-context";
import { OVERVIEW_LLM_LABELS } from "../../../utils/constant";
import { ENTITY_LABELS } from "../../../utils/labelMapping";
import classes from "./MarketComparisonItem.module.css";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import BrandAuditIndexBreakups from "../../../Component/BrandIndexHistory/BrandAuditIndexBreakups";
import {
  calcBrandIndexScore,
  getBrandPillarsAvg,
  getProductDimensionsAvg,
  getPurchaseCriteriaAvg,
  RBI_COLORS,
  RBI_WEIGHTS,
} from "../../../utils/brandIndexCalc";


export default function MarketItem({
  category,
  brandIndex,
  index,
  market,
  title,
  llm,
  persona,
  getTooltipProps = () => { },
  onRetry = () => { },
  sentimentSources = [],
  reachSources = [],
  selectedInput,
  isReachSourceValidated=false,
  isSentimentSourceValidated=false
}) {
  const [showBrandIndexBreakups, setShowBrandIndexBreakups] = useState(false);
  console.log("titleData",title,OVERVIEW_LLM_LABELS)
  // const llmName = LLM_OPTIONS.find((option) => option.value === title)?.name;
  const llmName = OVERVIEW_LLM_LABELS[title];

  const discoveryCtx = useContext(DiscoveryContext);

  let animation = discoveryCtx?.state?.showAnimation ?? true;
   const searchParams = new URLSearchParams(window.location.search);
  const isReporting = searchParams.get("isReporting") === "true";

  function LoadingSkeletion() {
    return (
      <>
        <Skeleton
          variant="rectangular"
          style={{
            zIndex: 1,
            flexGrow: 1,
            height: 220,
            flexBasis: "calc(50% - 12.5px)",
            backgroundColor: "rgb(0 0 0 / 11%)",
          }}
        />
      </>
    );
  }

  const renderConditionalTooltip = (getTooltipProps, label, value, sources, llm,isValidated) => {
    const showTooltip = llm?.toLowerCase().includes("search") && isValidated;

    if (value == null) return null;
    const scoreContent = <span className={showTooltip ? classes.sub_score : ""}>{value}</span>;
    return showTooltip  ? (
      <MUIToolTip {...getTooltipProps(undefined, label, sources, value, undefined, llm)}>
        {scoreContent}
      </MUIToolTip>
    ) : (
      scoreContent
    );
  };


  let cardContent = "";
  let loading = true;
  let hasError = false;
  const transactionStatus = discoveryCtx.state.transactionStatus;
  if (category && !hasError && brandIndex?.total) {
    cardContent = (
      <>
        {!category && (
          <div className={classes.add_container}>
            <MUIIconButton size="large">
              <AddCircleOutlineOutlinedIcon
                style={{ fontSize: 40 }}
                fontSize="large"
              />
            </MUIIconButton>
          </div>
        )}
        {brandIndex?.extras && (
          <MUIIconButton
            data-html2canvas-ignore
            onClick={() => setShowBrandIndexBreakups(true)}
            className={classes.settings}
          >
            <InfoOutlinedIcon />
          </MUIIconButton>
        )}
        <div className={classes.header}>
          <div className={classes.title_container}>
            <span className={classes.title}>{llmName}</span>
          </div>
        </div>
        <div className={classes.content}>
          {(() => {
            const isProduct = discoveryCtx.type === "product";
            const entity = discoveryCtx.entity;
            const coreAttributesData = discoveryCtx.core_attributes?.[llm]?.[category]?.[market]?.[persona];
            const categoryDimensionsData = discoveryCtx.category_dimensions?.[llm]?.[category]?.[market]?.[persona];
            const taxonomiesData = discoveryCtx.taxonomies?.[llm]?.[category]?.[market]?.[persona];
            const brandPillarsAvg = isProduct
              ? getProductDimensionsAvg(entity, taxonomiesData)
              : getBrandPillarsAvg(entity, coreAttributesData);
            const purchaseCriteriaAvg = getPurchaseCriteriaAvg(entity, categoryDimensionsData);
            const { total: rbiTotal, visNorm, sentNorm, pillarsNorm, purchaseNorm } =
              calcBrandIndexScore({ rank: brandIndex?.rank, favorability: brandIndex?.favorability, brandPillarsAvg, purchaseCriteriaAvg });
            const SCORE_CARDS = [
              { key: "visibility",       label: ENTITY_LABELS.rank,                                  weight: RBI_WEIGHTS.visibility,       raw: brandIndex?.rank,        max: 50 },
              { key: "sentiment",        label: "Sentiment",                                         weight: RBI_WEIGHTS.sentiment,        raw: brandIndex?.favorability, max: 50 },
              { key: "brandPillars",     label: isProduct ? ENTITY_LABELS.productDimension : ENTITY_LABELS.brandPillar,  weight: RBI_WEIGHTS.brandPillars,     raw: brandPillarsAvg,          max: 10 },
              { key: "purchaseCriteria", label: ENTITY_LABELS.purchaseCriteria,                      weight: RBI_WEIGHTS.purchaseCriteria, raw: purchaseCriteriaAvg,      max: 10 },
            ];
            return (
              <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%", padding: "0 4px" }}>
                <div style={{ flex: "0 0 55%", minWidth: 0 }}>
                  <WeightedDonutChart
                    total={rbiTotal}
                    visNorm={visNorm}
                    sentNorm={sentNorm}
                    pillarsNorm={pillarsNorm}
                    purchaseNorm={purchaseNorm}
                    size="small"
                    showLegend={false}
                  />
                </div>
                <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 6 }}>
                  {SCORE_CARDS.map((c) => {
                    const color = RBI_COLORS[c.key];
                    const weightPct = Math.round(c.weight * 100);
                    const rawDisplay = c.raw != null ? (c.max === 10 ? Number(c.raw).toFixed(1) : c.raw) : "—";
                    return (
                      <div key={c.key} style={{ background: "#fff", borderRadius: 6, padding: "4px 6px", border: `1.5px solid ${color}33`, display: "flex", alignItems: "center", gap: 4 }}>
                        <div style={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0, gap: 4 }}>
                          <span style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: color, flexShrink: 0, display: "inline-block" }} />
                          <Tooltip title={c.label} placement="top" enterDelay={400}>
                            <span style={{ fontSize: 10, fontWeight: 600, color: "#2d3748", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.label}</span>
                          </Tooltip>
                          <span style={{ fontSize: 9, color: "#8a94a6", flexShrink: 0 }}>{weightPct}%</span>
                        </div>
                        <div style={{ flexShrink: 0, textAlign: "right" }}>
                          <span style={{ fontSize: 13, fontWeight: 700, color }}>{rawDisplay}</span>
                          <span style={{ fontSize: 9, color: "#8a94a6" }}>/{c.max}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })()}
        </div>
      </>
    );
  } else if (transactionStatus === "RETRY") {
    hasError = true;
    loading = false;
  } else if (transactionStatus === "RUNNING") {
    hasError = false;
    loading = true;
  }

  if (category && hasError) {
    cardContent = (
      <ErrorView
        title="Error Fetching brand index score"
        message="Request Failed"
      />
    );
  }

  let categoryCard = "";
  if (cardContent) {
    categoryCard = (
      <MUICard
        variant="elevated"
        elevation={0}
        borderRadius={3}
        className={classes.card}
        width={"90%"}
      >
        {cardContent}
      </MUICard>
    );
  }

  return (
    <div
      className={classes.container}
      id="market_comparison"
      style={{
        backgroundColor: categoryCard ? "#eff4f8" : "inherit",
      }}
    >
      <Modal
        width={1200}
        open={showBrandIndexBreakups}
        handleClose={() => setShowBrandIndexBreakups(false)}
      >
        <BrandAuditIndexBreakups
          data={brandIndex?.extras}
          isOpen={showBrandIndexBreakups}
          type={discoveryCtx.type}
          llm={llm}
          category={category}
          market={market}
          persona={persona}
          selectedInput={selectedInput}
          brandProduct={discoveryCtx.entity}
          compIndexScoreMetaData={discoveryCtx.brand_scores?.[llm]?.[category]?.[market]?.[persona] ?? []}
        />
      </Modal>
      {categoryCard}
      {!brandIndex?.total && loading && !hasError && <LoadingSkeletion />}
    </div>
  );
}
